import { useState } from 'react';
import { motion } from 'framer-motion';

export type MascotMood = 'happy' | 'thinking' | 'celebrating';

interface Props {
  mood?: MascotMood;
  size?: number;
  className?: string;
}

// "Professor Buddy" — a dapper dog in a bowler hat + monocle.
// Photo lives at /public/mascot.jpg. If missing, falls back to an emoji tile
// so the UI still reads clearly.
export default function Mascot({ mood = 'happy', size = 120, className = '' }: Props) {
  const [failed, setFailed] = useState(false);

  const animate =
    mood === 'celebrating'
      ? { rotate: [0, -6, 6, -6, 0], y: [0, -6, 0] }
      : mood === 'thinking'
        ? { y: [0, -2, 0] }
        : { y: [0, -4, 0] };

  const transition =
    mood === 'celebrating'
      ? { duration: 0.9, repeat: Infinity, repeatDelay: 1.2 }
      : { duration: 3, repeat: Infinity, ease: 'easeInOut' as const };

  return (
    <motion.div
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
      animate={animate}
      transition={transition}
    >
      <div
        className="w-full h-full rounded-full overflow-hidden shadow-pop ring-4 ring-white bg-cream flex items-center justify-center"
        role="img"
        aria-label="Professor Buddy, your math tutor"
      >
        {failed ? (
          <span style={{ fontSize: size * 0.55, lineHeight: 1 }} aria-hidden="true">
            🐶
          </span>
        ) : (
          <img
            src="/mascot.jpg"
            alt=""
            className="w-full h-full object-cover"
            draggable={false}
            onError={() => setFailed(true)}
          />
        )}
      </div>
    </motion.div>
  );
}
